module.exports = __webpack_public_path__ + "assets/media/day36.f2cd351e.mp3";